import React from 'react';
import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import Image from '../../Utils/getImage';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const Viewdesign = ({ openviewDialog, setopenviewDialog, selectedDesign, selectedSubDesign, mode }) => {
    const title = mode === "Design Type" ? "View your design type list" : "View your design list";
    //handle close
    const handleClose = () => {
        setopenviewDialog(false);
    };

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openviewDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {mode === "Design Type" ? `view ${mode}` : `view ${mode}`}
                    <Typography>
                        {title}
                    </Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    {mode === "Design Type" ?
                        (
                            <section className="add-employee">
                                <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: "flex-start" }}>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                        <div className="add_emloyee-upload-file">
                                            <Image src={selectedDesign?.Bannerimage} alt="Bannerimage" width={190} height={190} />
                                            <Typography variant="h5">{selectedDesign?.designtype || "---"}</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                        <div className='add_emloyee-content'>
                                            <div className='add_emloyee-content-text'>
                                                <Typography variant='h5'>Design Type status</Typography>
                                                <label class="switch">
                                                    <input type="checkbox" checked={selectedDesign?.status} readOnly />
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                            <div className='add_emloyee-content-text'>
                                                <Typography variant='h5'>CreateddDate</Typography>
                                                <Typography>{selectedDesign?.createddDate || "---"}</Typography>
                                            </div>
                                            <div className='add_emloyee-content-text'>
                                                <Typography variant='h5'>UpdatedDate</Typography>
                                                <Typography>{selectedDesign?.UpdatedDate || "---"}</Typography>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </section>
                        ) : (
                            <section className="add-employee">
                                <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: "flex-start" }}>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                        <div className='add_emloyee-upload-file'>
                                            <Image src={selectedSubDesign?.Bannerimage} alt="Bannerimage" width={190} height={190} />
                                            <Typography variant="h5">{selectedSubDesign?.name || "---"}</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                        <div className='add_emloyee-content'>
                                            <div className='add_emloyee-content-text-1'>
                                                <Typography variant='h5'>Description</Typography>
                                                <Typography >{selectedSubDesign?.description || "---"}</Typography>
                                            </div>
                                        </div>
                                        <div className='add_emloyee-content' style={{ marginTop: 20 }}>
                                            <div className='add_emloyee-content-text'>
                                                <Typography variant='h5'>Design status</Typography>
                                                <label class="switch">
                                                    <input type="checkbox" checked={selectedSubDesign?.status} readOnly />
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                            <div className='add_emloyee-content-text'>
                                                <Typography variant='h5'>Price</Typography>
                                                <Typography>{`₹${selectedSubDesign?.price}` || "---"}</Typography>
                                            </div>
                                            <div className='add_emloyee-content-text'>
                                                <Typography variant='h5'>Created Date</Typography>
                                                <Typography>{new Date(selectedSubDesign?.createddDate).toLocaleDateString() || "---"}</Typography>
                                            </div>
                                            <div className='add_emloyee-content-text'>
                                                <Typography variant='h5'>Updated Date</Typography>
                                                <Typography>{new Date(selectedSubDesign?.UpdatedDate).toLocaleDateString() || "---"}</Typography>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </section>
                        )
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Viewdesign;